import {
  type FlowInformationExtractionBlockConfig,
  FlowInformationExtractionBlockSchema,
} from 'flow-schema';

import { InformationExtractionFormFields } from './FormFields';
import { informationExtractionDocumentationMarkdown } from './documentation';
import { getDefaultInformationExtractionConfig } from './utils';
import { type BlockConfigProps } from '../../types';

export const informationExtractionNodeConfig: BlockConfigProps<FlowInformationExtractionBlockConfig> =
  {
    defaultLabelPrefix: 'informationExtraction',
    nodeHandles: [{ type: 'target' }, { type: 'source' }],
    defaultConfig: getDefaultInformationExtractionConfig(),
    configFields: {
      schema: FlowInformationExtractionBlockSchema.shape.config,
      FormFields: InformationExtractionFormFields,
    },
    documentationMarkdown: informationExtractionDocumentationMarkdown,
  };
